import PropTypes from "prop-types";

import ActionPopOutOption from "@/view/ActionPopOutOption";
import getEventPropertiesContentType from "@/view/utils/getEventPropertiesContentType";

const propTypes = {
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  currentLevel: PropTypes.object,
  name: PropTypes.string,
  option: PropTypes.string,
  isSelected: PropTypes.bool,
  setCurrentFontSize: PropTypes.func,
};

const FontSizeOption = ({
  name,
  option,
  isSelected,
  setCurrentFontSize,
  contentId,
  contentType,
  currentLevel,
}) => {
  const eventProperties = {
    actionName: "Interact",
    objectType: "Content",
    actionPrefix: "Initiate",
    streamProperties: {
      content_id: currentLevel?.id ?? contentId,
      content_type: getEventPropertiesContentType(contentType),
      description: `Update text size to ${name}`,
    },
  };
  const dataProps = { "data-qa-selector": `set-font-size-${name}` };
  const handleSelectOption = () => {
    setCurrentFontSize(option);
  };

  return (
    <ActionPopOutOption
      dataProps={dataProps}
      eventProperties={eventProperties}
      icon={<></>}
      isSelected={isSelected}
      onClick={() => handleSelectOption()}
      title={`Text size: ${name}`}
    />
  );
};

FontSizeOption.propTypes = propTypes;
export default FontSizeOption;
